import { Tabs } from './Tabs';

export * from './Tabs';

export default Tabs;
